<template>
  <div class="container">
      <el-select style="width:120px;" v-model="type" @change="typeSelectChange">
          <el-option label="创建时间" :value="1"></el-option>
          <el-option label="激活时间" :value="2"></el-option>
          <el-option label="到期时间" :value="3"></el-option>
      </el-select>
      <el-date-picker
          v-model="comeTime"
          type="daterange"
          align="right"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="dateChange"
          :picker-options="pickerOptions">
        </el-date-picker>
  </div>
</template>

<script>
export default {
  props: {
  },
  data () {
    return {
      type: 1,
      comeTime: '', // 创建时间
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      search_sale: {
        startTime: '',
        endTime: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    typeSelectChange (value) {
      this.$emit('changeDateType', value)
    },
    dateChange (value) {
      if (value !== null) {
        value[0] = value[0].getFullYear() + '-' + (((value[0].getMonth() + 1) < 10) ? ('0' + (value[0].getMonth() + 1)) : (value[0].getMonth() + 1)) + '-' + ((value[0].getDate() < 10) ? ('0' + value[0].getDate()) : (value[0].getDate())) + ' 00:00:00'
        value[1] = value[1].getFullYear() + '-' + (((value[1].getMonth() + 1) < 10) ? ('0' + (value[1].getMonth() + 1)) : (value[1].getMonth() + 1)) + '-' + ((value[1].getDate() < 10) ? ('0' + value[1].getDate()) : (value[1].getDate())) + ' 23:59:59'
        this.search_sale.startTime = value[0]
        this.search_sale.endTime = value[1]
      } else {
        this.search_sale.startTime = ''
        this.search_sale.endTime = ''
      }
      this.$emit('changeDateRange', [this.search_sale.startTime, this.search_sale.endTime])
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  margin-right: 10px;
}
</style>
